import { render, staticRenderFns } from "./SideComponent.vue?vue&type=template&id=ffda7370&scoped=true&"
import script from "./SideComponent.vue?vue&type=script&lang=js&"
export * from "./SideComponent.vue?vue&type=script&lang=js&"
import style0 from "./SideComponent.vue?vue&type=style&index=0&id=ffda7370&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffda7370",
  null
  
)

export default component.exports